import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { usePermalinkToken } from '../../../../utils/session/permalinkToken'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useChildrenServiceOrders = () => React.useContext(Context)?.serviceOrders || []

const QUERY = gql`
  query ServiceOrders($filter: ServiceOrderFilter, $sort: ServiceOrderSort, $permalinkParentToken: String) {
    serviceOrders(filter: $filter, limit: 9999, sort: $sort, permalinkParentToken: $permalinkParentToken) {
      id
      replies {
        id
        value
        questionId
        blockIndex
      }
    }
  }
`

const ChildrenServiceOrderLoader = ({ children, parentId }) => {
  const permalinkParentToken = usePermalinkToken()
  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: { parentIds: [parentId] },
      sort: { field: 'ID', type: 'ASC' },
      permalinkParentToken
    },
    client: serviceOrdersClient,
    fetchPolicy: 'no-cache'
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrders}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ChildrenServiceOrderLoader
